import React from 'react';
import { useTranslation } from 'react-i18next';

import './_practice-scope-tag.scss';

/**
 * PracticeScopeTag - Chip shown in the practice header when the session is a volatile
 * single-KC practice launched from "Áreas de mejora" (TANAI-2087): "🎯 Áreas de mejora".
 * It takes the place of the `ChallengeTypeTag` for those sessions, so the student always knows
 * where the practice came from, and it reuses the section's own label and orange/🎯 theme
 * (`improvement_areas_title`, the same key the "Mi progreso" panel renders) instead of
 * introducing a second wording for the same concept.
 *
 * The scope is fixed by definition, so the chip takes no props. The emoji is decorative and
 * lives in CSS (`::before`), same as its sibling `ChallengeTypeTag`; the accessible name is the
 * translated label.
 */
function PracticeScopeTag(): JSX.Element {
  const { t } = useTranslation(['chatbot']);

  return <span className="practice-scope-tag">{t('improvement_areas_title')}</span>;
}

export default PracticeScopeTag;
